export default __webpack_public_path__ + "static/media/pizza.be3ef5db.svg";